import React from 'react';
import PropTypes from 'prop-types';

import withMessages from 'component-utilities/intl';
import displayName from 'component-lib/displayName';

import styles from './DocumentViewer.scss';

const BASE_KEY = 'components.document_viewer';

function DocumentViewerHeaderComponent(props) {
    return (<div className={styles['dv-header']}>
        <span
            role="presentation"
            className={styles['btn-close']}
            onClick={props.onClose}
            title={props.getMessage(`${BASE_KEY}.close`)}
        />
        <span
            role="presentation"
            className={styles['btn-download']}
            onClick={props.onDownload}
            title={props.getMessage(`${BASE_KEY}.download_attachment`)}
        >
            <span className={styles.file}>
                <span className={styles['file-icon']}>
                    <span className={styles[`icon-${props.file.type}`]} />
                </span>
                <span
                    className={styles['file-name']}
                    data-file={props.file.filename}
                >
                    {props.file.filename}
                </span>
                {
                    props.userCanDownloadDocuments &&
                    <span className={styles['icon-download']} />
                }
            </span>
        </span>
    </div>)
}

DocumentViewerHeaderComponent.propTypes = {
    userCanDownloadDocuments: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onDownload: PropTypes.func.isRequired,
    file: PropTypes.shape({
        type: PropTypes.string.isRequired,
        filename: PropTypes.string.isRequired,
        downloadUrl: PropTypes.string.isRequired,
    }).isRequired,
    getMessage: PropTypes.func.isRequired,
};

const DocumentViewerHeader = withMessages(DocumentViewerHeaderComponent);
DocumentViewerHeader.displayName = displayName('DocumentViewer/Header');

export default DocumentViewerHeader;
